import styled from "styled-components";

export const DeleteHeader = styled.div`
font-size: 16px;
font-weight: 700;
line-height: 26px;
text-align: center;
text-underline-position: from-font;
text-decoration-skip-ink: none;
color: #FF1414;
`